import SelectRange from './SelectRange';
export default SelectRange;